import React, { useState } from "react";
import { Link } from "react-router-dom";
import { SuccessButton, SecondaryButton, ContinueIcon, CopyIcon } from "../../design-system";
import { APP_DOMAIN } from "../utils/config";

const LoggedInCTAButtons = ({ username }) => {
  const [isCopyToastMounted, setIsCopyToastMounted] = useState(false);
  const [isCopyToastVisible, setIsCopyToastVisible] = useState(false);

  return (
    <div className="space-y-4">
      <Link to={`/edit/${username}`}>
        <SuccessButton
          fullWidth={true}
          leftIcon={<ContinueIcon className="mr-2" />}
          className="whitespace-nowrap"
        >
          Continue creating
        </SuccessButton>
      </Link>
      <SecondaryButton
        type="button"
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(`Create your professional website with ${APP_DOMAIN}`);
            setIsCopyToastMounted(true);
            requestAnimationFrame(() => setIsCopyToastVisible(true));
            setTimeout(() => setIsCopyToastVisible(false), 1700);
            setTimeout(() => setIsCopyToastMounted(false), 2000);
          } catch (e) {
            // no-op
          }
        }}
        fullWidth={true}
        leftIcon={<CopyIcon className="mr-2" />}
        className="dark:bg-white dark:text-gray-900 dark:border-white dark:hover:bg-gray-100"
      >
        Share with friends
      </SecondaryButton>
      {isCopyToastMounted && (
        <div className={`px-4 py-2 text-xs text-green-600 bg-green-50 border-l-2 border-green-500 inline-block rounded transition-all duration-300 ease-out ${isCopyToastVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-1'}`}>
          Copied to clipboard
        </div>
      )}
    </div>
  );
};

export default LoggedInCTAButtons;

